<template>
    <div class="all">
      <my-title :msg="title"></my-title>
      <div class="MyPoints">
        <div class="MyPoints_title">当前可用积分</div>
        <el-row>
          <el-col :span="6">
            <div class="grid-content1">
              <span>{{DataList.inte_price}}</span>积分
              <p>说明:订单完成后积分才会到账</p>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="grid-content2">
              <el-button type="warning" style="background: #e4393c;border: none;padding: 9px 12px;" @click="getDuihuan">立即兑换</el-button>
<!--              <el-button type="warning" style="background: #e4393c;border: none;padding: 9px 12px;">礼品购物车</el-button>-->
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="MyPoints_form">
        <ul>
          <li :class="type == 1?'ClassBor':''" @click="getType(type)">订单积分明细</li>
          <li :class="type == 2?'ClassBor':''" @click="getType(type)">兑换礼品明细</li>
        </ul>
        <div class="MyPoints_form_ul">
          <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;">
            <el-col :span="5"><div class="grid-content">序号</div></el-col>
            <el-col :span="5"><div class="grid-content">类型</div></el-col>
            <el-col :span="5"><div class="grid-content">订单编号</div></el-col>
            <el-col :span="5"><div class="grid-content">积分</div></el-col>
            <!--              <el-col :span="4"><div class="grid-content">获取积分数</div></el-col>-->
            <el-col :span="4"><div class="grid-content">时间</div></el-col>
          </el-row>
          <el-row style="background-color: #e7e7e7;border: 1px solid #d1d1d1;" v-for="(item,index) in DataListLint" :key="index">
            <el-col :span="5"><div class="grid-content">{{item.id}}</div></el-col>
            <el-col :span="5"><div class="grid-content">{{item.type == 1?'订单':'兑换'}}</div></el-col>
            <el-col :span="5"><div class="grid-content">{{item.order_num}}</div></el-col>
            <el-col :span="5"><div class="grid-content">{{item.inte_price?item.inte_price:0}}</div></el-col>
            <el-col :span="4"><div class="grid-content" v-if="item.add_time">{{item.add_time | filterDate('yyyy/MM/dd')}}</div></el-col>
            <el-col :span="4"><div class="grid-content" v-if="item.add_time == null"> 暂无 </div> </el-col>
          </el-row>
        </div>
      </div>
    </div>
</template>

<script>
  import {MyInit} from '../api/Mycen'
    export default {
        name: "MyPoints",
        data(){
          return{
            title:"我的积分",
            type:1,
            DataList:{},
            DataListLint:[],
          }
        },
      mounted() {
        this.init()
      },
      methods:{
          init(){
            MyInit({type:this.type}).then(res=>{
              this.DataList = res
              this.DataListLint = res.result.data
            })
          },
          getType(e){
            if (e == 1){
              this.type = 2
              this.init()
            }else {
              this.type = 1
              this.init()
            }
          },
          getDuihuan(){
            this.$emit('type',5)
          }
        }
    }
</script>

<style scoped lang="less">
  @import "css/MyPoints";
</style>



// WEBPACK FOOTER //
// src/components/MyPoints.vue